import { useIsStaff } from '@vimeo/core/hooks/use-is-staff/useIsStaff';
import { SubjectKeyTypes, useEppoAssignment, VariationTypes } from '@vimeo/eppo';
import { useViewer } from '@vimeo/viewer';

export const useNewIPSPanelAssignment = () => {
  const viewer = useViewer();
  const currentUserIsStaff = useIsStaff();

  // get user and team information
  const user = viewer?.user;
  const userId = user?.id;
  const teamUser = viewer?.teamUser;
  const ownerId = teamUser?.ownerId;
  const cuid = (ownerId || userId) ?? 0;
  const vuid = viewer?.vuid;

  // get additional data for the experiment
  const isEnterprise = !!(teamUser
    ? teamUser?.accountType === 'enterprise'
    : user?.capabilities?.hasEnterprise);
  const isFree = teamUser ? !teamUser?.hasPaid : !user?.capabilities?.hasPaid;
  const isPaid = (teamUser ? teamUser?.hasPaid : user?.capabilities?.hasPaid) ?? false;
  const isStaff = currentUserIsStaff;
  const accountType = viewer?.teamUser?.accountType ?? viewer?.user?.account ?? 'unknown';

  const { assignment } = useEppoAssignment({
    flagKey: 'in-product-support-panel',
    subject: {
      key: vuid,
      keyType: SubjectKeyTypes.VUID,
      additionalData: {
        cuid,
        isEnterprise,
        isFree,
        isPaid,
        isStaff,
        accountType,
      },
    },
    assignmentType: VariationTypes.STRING,
    defaultAssignment: 'legacy-help',
  });

  return assignment === 'ips-panel';
};
